import { ConfigProvider } from "antd";
import { ReactNode } from "react";
import { useAntTheme } from "hooks/useAntTheme";

/**
 * Shared Ant theme wrapper for the per-item editor controls (buttons,
 * number inputs) that live in the side-menu tabs. Gives them the borderless,
 * base-coloured look they had in the (now removed) floating settings toolbar.
 *
 * Centralised here so every control surface stays visually consistent instead
 * of duplicating the same token block in each tab.
 */
export const ItemControlsConfigProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { theme } = useAntTheme();

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorText: theme.colorTextBase,
            colorIcon: theme.colorTextBase,
            colorIconHover: theme.colorTextBase,
            colorBorder: "transparent",
            defaultShadow: "none",
            defaultColor: theme.colorTextBase,
            defaultBorderColor: theme.colorBorder,
          },
          InputNumber: {
            addonBg: "transparent",
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};
